
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

// Global Router
import { HashRouter as Router, Route, Switch } from 'react-router-dom';

import './style/global.css';
import './style/animate.css';
import 'antd/dist/antd.css';

// Theme Global Language
import enUS from 'antd/lib/locale-provider/en_US';
import { ConfigProvider } from 'antd';

// Main App
import App from './App';
import Login from './pages/login';
import Register from './pages/register';
import NoMatch from './pages/nomatch/';
import Reset from './pages/reset';
import OnBoardLanding from './pages/onboarding';

// Authentication
import Auth from './auth';

// Redux Store
import store from './store/store';

ReactDOM.render(
    <Provider store={store}>
        <ConfigProvider locale={enUS}>
            <Router>
                <Switch>
                    <Route exact path="/login" component={ Login } />
                    <Route exact path="/register/:company" component={ Register } />
                    <Route exact path="/reset" component={ Reset } />
                    <Route exact path="/onboarding/:id/:name" component={ OnBoardLanding } />
                    <Route path="/" component={ Auth( App ) } />
                    <Route component={ NoMatch }/>
                </ Switch>
            </ Router>
        </ ConfigProvider>
    </Provider>, 
document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js